import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { HiMenu } from "react-icons/hi"; // Menu Icon
import { twMerge } from "tailwind-merge";
import Darklogo from "../../assets/Sidebar/Dark_logo.png";
import Shortlogo from "../../assets/Sidebar/Logo_short.png";
import avatar from "../../assets/Icons/user-avatar.png";
import { currencyFormatter } from "../../utils/formatting";
import showToast from "../../utils/toastNotifications";
import { errorMessages } from "../../constants/frontendErrorMessages";
import { getUserWallet } from "../../store";
import { useThunk } from "../../hooks/useThunk";
import Notifications from "./Notifications";

const Navbar = ({ toggleSidebar, isSidebarOpen }) => {
 
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector((state) => state.auth.user);
  const wallet = useSelector((state) => state.user.wallet); // wallet
  const isWalletFetching = useSelector((state) => state.user.isWalletFetching); // wallet isFetching state
  const [isMissingOrMalformed, setIsMissingOrMalformed] = useState(false);

  const [doGetUserWallet] = useThunk(getUserWallet);
  
  const handleProfileNavigation = () => {
    if (location.pathname !== "/edit-profile") {
      navigate("/edit-profile");
    }
  };

  //fetch user Wallet
  useEffect(() => {
    fetchUserWallet();
  }, []);

  const fetchUserWallet = async () => {
    const result = await doGetUserWallet();
    if (!result.success) {
      showToast("error", result?.error?.message || errorMessages.ERROR_OCCURRED)
    }
  };

  return (
    <nav
      className={twMerge(
        `h-24 flex items-center px-4 xl:px-8 min-w-[320px] justify-between bg-white fixed top-0 transition-all duration-300 z-20 w-full xl:w-[calc(100vw-256px)]`,
        isSidebarOpen ? "ml-0" : ""
      )}
    >
      <div className="flex flex-row justify-between items-center w-full h-12 ">
        {/* Menu Icon and Logo for Small Screens */}
        <div className="flex flex-row xl:hidden items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="text-primary text-2xl xl:hidden"
          >
            <HiMenu size={32} />
          </button>
          {/* <img
            src={Darklogo}
            alt="Logo"
            className="h-6 min-[350px]:h-8 w-auto object-contain block xl:hidden"
          /> */}
          <img
            src={Darklogo}
            alt="Logo"
            className="h-8 w-auto object-contain hidden sm:block xl:hidden"
          />
          <img
            src={Shortlogo}
            alt="Logo"
            className="h-8 w-auto object-contain block sm:hidden"
          />
        </div>

        {/* Title */}
        <div className="hidden xl:block">
          <h1 className="text-primary flex items-start font-roboto font-semibold text-[24px] ml-4 leading-5">
            {location.pathname === "/" ? "Dashboard" :
              location.pathname === "/calculation" ? "Order Now" :
                location.pathname === "/raise-complaint" ? "Completed Orders" :
                  [location.pathname?.split("/")[1]]
                    ?.filter(Boolean)
                    ?.map(
                      (word) =>
                        word
                          .split("-") // Split by hyphen
                          .map((subWord) =>
                            subWord.replace(subWord[0], subWord[0]?.toUpperCase())
                          ) // Capitalize each subword
                          .join(" ") // Join the subwords with a space
                    )
                    .join(" ")}
          </h1>
        </div>

        {/* Right Section */}
        <div className="h-[48px] flex items-center justify-center gap-0 mt-2 bg-white rounded-full ">
          {/* wallet amount */}
          <div className="py-2 px-2 mr-5 sm:px-4 bg-light-blue rounded-[8px]">
            <h1 className="font-roboto text-level-3 font-medium text-blue-shades">
              {isWalletFetching ? (
                <ClipLoader
                  loading={isWalletFetching}
                  speedMultiplier={0.5}
                  size={22}
                  color="#60a5fa"
                />
              ) : wallet?.amount == null || wallet?.amount === "" ? (
                "$00.00"
              ) : (
                currencyFormatter.format(wallet?.amount || 0.0) || "$ 00.00"
              )}
            </h1>
          </div>

          <Notifications/>
          <div
            className="flex items-center hover:cursor-pointer bg-white"
            onClick={handleProfileNavigation}
          >
            <div className="hidden md:flex flex-col justify-start items-start mr-2 sm:mr-4">
              <span className="text-secondary font-inter font-normal text-level-5 leading-[13px] whitespace-nowrap">
                {userData?.firstName} {userData?.lastName}
              </span>
              <p className="text-secondary font-inter text-[8px] font-light leading-[13px]">
                {userData?.email}
              </p>
            </div>
            <img
              src={
                isMissingOrMalformed || !userData?.profilePicture
                  ? avatar
                  : userData?.profilePicture
              }
              alt="User Profile"
              onError={() => {
                setIsMissingOrMalformed(true);
              }}
              className="w-8 h-8 rounded-full object-cover"
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
